// OData shapes for AIAgentScheduleInternalTask (`ai/schedule/tasks`).
// OperationType was removed — use triggerType (Scheduled=1, Manual=2).

export default {
  paged: {
    // `chatThreadId` feeds joinChat on Run; `lastEventSequence` guards stale
    // `ai-agent-schedule` socket events (UX §5.5).
    select:
      'id,created,number,triggerType,status,requestedOperation,scheduledDate,processingDate,processedDate,processingAttempts,latestActivity,latestActivityType,currentToolName,chatThreadId,lastEventSequence,creator',
    // `creator` is a JsonDataCreator object — not searchable via contains().
    searchSelect: ['number'],
  },
  detail: {
    // Full monitor snapshot (UX §3.3): execution-mode snapshot, materialized
    // instructions, worker heartbeat/node and latest-activity timestamp.
    select:
      'id,created,updated,number,triggerType,executionMode,status,requestedOperation,instructions,scheduledDate,processingDate,processedDate,processingAttempts,observations,latestActivity,latestActivityType,latestActivityAt,currentToolName,lastProcessingHeartbeat,processingNodeId,processingNodeName,aiAgentScheduleId,aiAgentId,chatThreadId,userTaskId,ownerUserId,lastEventSequence,creator',
  },
};
